import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './PageTransition.css';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState('fadeIn');

  useEffect(() => {
    if (location !== displayLocation) {
      setTransitionStage('fadeOut');
    }
  }, [location, displayLocation]);

  const slideVariants = {
    initial: (direction) => ({
      x: direction === 'right' ? '100%' : direction === 'left' ? '-100%' : 0,
      opacity: 0,
      scale: 0.8,
      filter: 'blur(10px)',
      rotateY: direction === 'right' ? 20 : direction === 'left' ? -20 : 0,
    }),
    in: {
      x: 0,
      opacity: 1,
      scale: 1,
      filter: 'blur(0px)',
      rotateY: 0,
    },
    out: (direction) => ({
      x: direction === 'right' ? '-100%' : direction === 'left' ? '100%' : 0,
      opacity: 0,
      scale: 1.05,
      filter: 'blur(8px)',
      rotateY: direction === 'right' ? -10 : direction === 'left' ? 10 : 0,
    }),
  };

  const pageTransition = {
    type: 'tween',
    ease: [0.54, 0.35, 0.29, 0.99],
    duration: 0.8,
  };

  const getDirection = (pathname) => {
    const routes = ['/', '/team', '/login'];
    const currentIndex = routes.indexOf(displayLocation.pathname);
    const nextIndex = routes.indexOf(pathname);
    
    if (nextIndex > currentIndex) return 'right';
    if (nextIndex < currentIndex) return 'left';
    return 'none';
  };

  return (
    <div className="page-transition-container">
      <AnimatePresence
        mode="wait"
        onExitComplete={() => {
          if (transitionStage === 'fadeOut') {
            setDisplayLocation(location);
            setTransitionStage('fadeIn');
          }
        }}
      >
        <motion.div
          key={displayLocation.pathname}
          custom={getDirection(location.pathname)}
          className="page-transition-wrapper"
          variants={slideVariants}
          initial="initial"
          animate="in"
          exit="out"
          transition={pageTransition}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default PageTransition; 